import PropTypes from 'prop-types';
import keymirror from 'keymirror';

const questionLayoutList = keymirror({
  centered: null,
  default: null,
});

export default questionLayoutList;

export const questionLayoutPropType = PropTypes.oneOf(
  Object.keys(questionLayoutList),
);
